import React, { useContext, useMemo, useEffect, useState } from 'react';
import { ExchangesFees, PaymentInfoContext,PaymentMode } from '../../App';
import { Typography } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import {zeroDecimalCurrency} from '../../utils/index';
import {CurrencyFormats, PaymentModes, formatNumberToLocaleString} from '../../utils/index';
import {LoadingContext} from "../../pages/CheckoutForm";

const CurrencySelect = ({ formik, currencyList }) => {
  const classes = useStyles();
  const exchangesFees = useContext(ExchangesFees);
  const paymentMode = useContext(PaymentMode);
  const paymentInfo = useContext(PaymentInfoContext);
  const isLoading = useContext(LoadingContext);
  const {t} = useTranslation();
  const [convertedAmount, setConversion]=useState();


  // TODO: Move to utils
  const getAmount = (currency, amount) => {
    const currencyItem = currencyList?.find(x => x.iso === currency);
    if (currency === paymentInfo?.currency) {
      return zeroDecimalCurrency(currencyItem) ? parseFloat(amount?.toFixed(0)).toFixed(2) : amount?.toFixed(2);
    }
    const exchangeItem = exchangesFees?.find((x) => x.currencyTo === currency);
    let payAmount = amount * exchangeItem?.rate + ((amount * exchangeItem?.rate) / 100) * exchangeItem?.feePercAmount;
    return zeroDecimalCurrency(currencyItem) ? parseFloat(payAmount?.toFixed(0)).toFixed(2) : payAmount?.toFixed(2);
  };

  const getCurrency = useMemo(() => {
    return currencyList?.find((item) => item?.iso !== paymentInfo?.currency)?.iso;
  }, [paymentInfo?.currency, currencyList])

  const getRate = useMemo(() => {
    const exchangeItem = exchangesFees?.find((x) => x?.currencyTo === getCurrency);
    return (
      <>
        {(exchangeItem?.rate * (10000 + exchangeItem?.feePercAmount * 100)) / 10000} {exchangeItem?.currencyTo}
      </>
    );
  }, [exchangesFees, getCurrency]);

  const handleChange = (e, value) => {
    if (!value) return
    formik.setFieldValue('currency', value);
    formik.setFieldValue('amount', getAmount(value, paymentInfo?.amount));
  };

  const getAmountStr = (currency, amount) => {
    const price = getAmount(currency, amount);
    const precision = zeroDecimalCurrency(currencyList?.find(x => x.iso === currency) ?? { decimals: paymentInfo?.currencyDecimals }) ? 0 : 2;
    return CurrencyFormats(price, precision);
  }

  useEffect(() => {
    if (paymentInfo) {
      formik.setFieldValue('amount', getAmount(formik.values.currency, paymentInfo?.amount));
    }
  }, [paymentInfo, formik.values.currency]);

  return paymentInfo?.isConvertAllowed && currencyList?.length > 1  && paymentMode != PaymentModes.Token? (
    <div className={classes.currenciesContainer}>
      <div className={classes.title}>
        <Typography variant="h3" className={'input_label_text'}>{t('Pay_in')} {getCurrency}</Typography>
        <div className={`${classes.rate} fx_conversion_text`}>
          1 {paymentInfo.currency} = {getRate}
        </div>
      </div>
      {/* <Typography variant="body2" className={classes.currenciesHeaderText}>
        Benefit from our market beating exchange rate.
      </Typography> */}
      <ToggleButtonGroup
        size="small"
        exclusive
        value={formik.values.currency}
        onChange={handleChange}
        name="currency"
        text={convertedAmount}
        className={`${classes.buttonGroup} input_label_text`}
        disabled={isLoading}
      >
        {currencyList?.map((item, index) => (
          <ToggleButton key={index} value={item.iso} aria-label={item.iso} className={`${classes.button} pay_method_text currency-toggle`}>
           <span className="pay_method_text">{item?.iso} {getAmountStr(item?.iso, paymentInfo?.amount)}</span>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {/* <Typography variant="body1">
        We offer the best available {getCurrency} price for this booking.
      </Typography>
      <Typography variant="body2" className={classes.currenciesHeaderText}>
        If your bank offers you a better rate let us know and we will pay you double the difference.
      </Typography> */}
    </div>
  ) : null;
};

export default CurrencySelect;
